module.exports = __webpack_public_path__ + "img/orange3.73a41cd9.png";